export const BUILDER_PUBLIC_API_KEY = 'YJIGb4i01jvw0SRdL5Bt'; // ggignore
export const QWIK_PUBLIC_API_KEY = 'fe30f73e01ef40558cd69a9493eba2a2'; // ggignore
export const BUILDER_TOP_BAR_MODEL = 'oss-top-bar';
export const BUILDER_FOOTER_MODEL = 'oss-footer';
export const QWIK_MODEL = 'content-page';
